export default __webpack_public_path__ + "static/media/checked-blue.2a5ebb2d.webp";